import React, { useEffect, useState } from 'react';
import { useUser } from '../UserContext';
import { useNavigate, Link } from 'react-router-dom';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
import './index.css';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const Grafico = () => {
  const { userInfo } = useUser();
  const navigate = useNavigate();

  const [dadosReceber, setDadosReceber] = useState([]);
  const [dadosDev, setDadosDev] = useState([]);
  const [dadosCont, setDadosCont] = useState([]);
  const [filtroMes, setFiltroMes] = useState('');
  const [filtroAno, setFiltroAno] = useState('');

  useEffect(() => {
    if (!userInfo?.id) {
      navigate('/');
    }
  }, [userInfo, navigate]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = 'Tem certeza de que deseja sair desta tela?';
      event.preventDefault();
      event.returnValue = message;
      return message;
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);

  useEffect(() => {
    if (!userInfo?.id || !userInfo?.url) return;
  
    fetch(userInfo.url + '/grafico')
      .then(response => response.json())
      .then(data => setDadosReceber(data))
      .catch(error => console.error('Erro ao buscar dados de receber:', error));
  
    fetch(userInfo.url + '/graficodev')
      .then(response => response.json())
      .then(data => setDadosDev(data))
      .catch(error => console.error('Erro ao buscar dados de dev:', error));
  
    fetch(userInfo.url + '/graficoContratos')
      .then(response => response.json())
      .then(data => setDadosCont(data))
      .catch(error => console.error('Erro ao buscar dados de Contratos:', error));
  }, [userInfo]);

  const mesesUnicos = [...new Set(
    [...dadosReceber, ...dadosDev, ...dadosCont]
      .map(item => item.MES?.split('/')[0])
      .filter(Boolean)
  )];
  
  const anosUnicos = [...new Set(
    [...dadosReceber, ...dadosDev, ...dadosCont]
      .map(item => item.MES?.split('/')[1])
      .filter(Boolean)
  )];  

  const filtrarPorMesEAno = (item) => {
    if (!item.MES) return false;
    const [mes, ano] = item.MES.split('/');
    return (!filtroMes || filtroMes === mes) && (!filtroAno || filtroAno === ano);
  };
  
  // ---------- Gráfico 1: Valores por Banco ----------
  const dadosReceberFiltrados = dadosReceber.filter(filtrarPorMesEAno);
  const labelsReceber = [...new Set(dadosReceberFiltrados.map(item => item.MES))];
  const bancos = [...new Set(dadosReceberFiltrados.map(item => item.BANCO))];

const datasetsReceber = bancos.map(banco => ({
      label: banco,
      data: labelsReceber.map(mes => {
        const item = dadosReceberFiltrados.find(d => d.MES === mes && d.BANCO === banco);
        return item ? item.VALOR : 0;
      }),
      backgroundColor: `#${Math.floor(Math.random() * 16777215).toString(16)}`
    }));

  const dataReceber = {
    labels: labelsReceber,
    datasets: datasetsReceber
  };

  // ---------- Gráfico 2: Criados vs Finalizados ----------
  const normalizaMes = (mes) => mes.toString().trim();

  const dadosDevFiltrados = dadosDev.filter(filtrarPorMesEAno);
  
  const agrupadoDev = {};
  
  dadosDevFiltrados.forEach(item => {
    const mes = normalizaMes(item.MES);
    if (!agrupadoDev[mes]) {
      agrupadoDev[mes] = { CRIADOS: 0, FINALIZADOS: 0 };
    }
    agrupadoDev[mes].CRIADOS += item.CRIADOS || 0;
    agrupadoDev[mes].FINALIZADOS += item.FINALIZADOS || 0;
  });
  
  const labelsDev = Object.keys(agrupadoDev);
  const dataCriados = labelsDev.map(mes => agrupadoDev[mes].CRIADOS);
  const dataFinalizados = labelsDev.map(mes => agrupadoDev[mes].FINALIZADOS);
  
  const dataDev = {
    labels: labelsDev,
    datasets: [
      {
        label: 'Criados',
        data: dataCriados,
        backgroundColor: 'rgba(54, 162, 235, 0.6)',
      },
      {
        label: 'Finalizados',
        data: dataFinalizados,
        backgroundColor: 'rgba(75, 192, 192, 0.6)',
      }
    ]
  };  

    // ---------- Gráfico 3: Intalados vs Cancelados ----------
    const dadosContFiltrados = dadosCont.filter(filtrarPorMesEAno);

    const agrupadoCont = {};

    dadosContFiltrados.forEach(item => {
      const mes = item.MES?.trim();
      if (!agrupadoCont[mes]) {
        agrupadoCont[mes] = { INSTALADOS: 0, CANCELADOS: 0 };
      }
      agrupadoCont[mes].INSTALADOS += item.INSTALADOS || 0;
      agrupadoCont[mes].CANCELADOS += item.CANCELADOS || 0;
    });

    const labelsCont = Object.keys(agrupadoCont);
    const dataInstalados = labelsCont.map(mes => agrupadoCont[mes].INSTALADOS);
    const dataCancelados = labelsCont.map(mes => agrupadoCont[mes].CANCELADOS);

    const dataCont = {
      labels: labelsCont,
      datasets: [
        {
          label: 'Instalados',
          data: dataInstalados,
          backgroundColor: 'rgba(153, 102, 255, 0.6)',
        },
        {
          label: 'Cancelados',
          data: dataCancelados,
          backgroundColor: 'rgba(255, 99, 132, 0.6)',
        }
      ]
    };

    const nomesDosMeses = {
      '1': 'Janeiro', '2': 'Fevereiro', '3': 'Março', '4': 'Abril',
      '5': 'Maio', '6': 'Junho', '7': 'Julho', '8': 'Agosto',
      '9': 'Setembro', '10': 'Outubro', '11': 'Novembro', '12': 'Dezembro'
    };

  return (
    <>
      <header className="header">
        <h2>Gráficos de Análise</h2>
      </header>

      <div className="grafico-container">
        <div className="cab">
          <Link to="/menu" className="link-style">Voltar ao menu</Link>

          <div className="filtro-mes-ano">
          <label>Mês:</label>
          <select value={filtroMes} onChange={(e) => setFiltroMes(e.target.value)}>
            <option value="">Todos</option>
            {mesesUnicos.map(mes => (
              <option key={mes} value={mes}>{nomesDosMeses[mes]}</option>
            ))}
          </select>

            <label>Ano:</label>
            <select value={filtroAno} onChange={(e) => setFiltroAno(e.target.value)}>
              <option value="">Todos</option>
              {anosUnicos.map(ano => (
                <option key={ano} value={ano}>{ano}</option>
              ))}
            </select>
          </div>
        </div>

        {/* Gráfico 1 - Receber */}
        <section className="grafico-wrapper">
          <h3>Gráfico Financeiro (por Banco)</h3>
          {dadosReceberFiltrados.length > 0 ? (
            <Bar
              data={dataReceber}
              options={{
                responsive: true,
                maintainAspectRatio: false,
                plugins: { legend: { position: 'top' } }
              }}
              height={400}
            />
          ) : (
            <p>Carregando dados do gráfico de receber...</p>
          )}
        </section>

        {/* Gráfico 2 - Criados vs Finalizados */}
        <section className="grafico-wrapper">
          <h3>Gráfico de Demandas Criadas vs Finalizadas</h3>
          {dadosDevFiltrados.length > 0 ? (
            <Bar
              data={dataDev}
              options={{
                responsive: true,
                maintainAspectRatio: false,
                plugins: { legend: { position: 'top' } }
              }}
              height={400}
            />
          ) : (
            <p>Carregando dados do gráfico de desenvolvimento...</p>
          )}
        </section>

        {/* Gráfico 3 - Instalados vs Cancelados */}
        <section className="grafico-wrapper">
          <h3>Gráfico de contratos Instalados vs Cancelados</h3>
          {dadosContFiltrados.length > 0 ? (
            <Bar
            data={dataCont}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              plugins: { legend: { position: 'top' } }
            }}
          />          
          ) : (
            <p>Carregando dados do gráfico de contratos...</p>
          )}
        </section>
      </div>
    </>
  );
};

export default Grafico;